import React from 'react';
import Styles from './PricingHero.module.scss';

const PricingHero = () => {
  return (
    <div className={Styles.hero}>
      <div className={Styles.hero__content}>
        <h1 className={Styles.hero__headline}>
          Create Engaging, Human-Sounding Content Across Multiple Platforms
        </h1>

        <p className={Styles.hero__subheadline}>
          Join{' '}
          <span className={Styles.hero__highlight}>
            thousands of businesses
          </span>{' '}
          and thought leaders who save 20+ hours every month with Vocable's AI
          multi-channel content campaigns
        </p>

        <div className={Styles.hero__rating}>
          <div className={Styles.hero__rating__container}>
            <div className={Styles.hero__rating__stars}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 1L12.2451 6.90983H18.5106L13.6327 11.1803L15.8779 17.0902L10 13.8197L4.12215 17.0902L6.36729 11.1803L1.48944 6.90983H7.75492L10 1Z"
                  fill="#FDB022"
                />
              </svg>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 1L12.2451 6.90983H18.5106L13.6327 11.1803L15.8779 17.0902L10 13.8197L4.12215 17.0902L6.36729 11.1803L1.48944 6.90983H7.75492L10 1Z"
                  fill="#FDB022"
                />
              </svg>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 1L12.2451 6.90983H18.5106L13.6327 11.1803L15.8779 17.0902L10 13.8197L4.12215 17.0902L6.36729 11.1803L1.48944 6.90983H7.75492L10 1Z"
                  fill="#FDB022"
                />
              </svg>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 1L12.2451 6.90983H18.5106L13.6327 11.1803L15.8779 17.0902L10 13.8197L4.12215 17.0902L6.36729 11.1803L1.48944 6.90983H7.75492L10 1Z"
                  fill="#FDB022"
                />
              </svg>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 1L12.2451 6.90983H18.5106L13.6327 11.1803L15.8779 17.0902L10 13.8197L4.12215 17.0902L6.36729 11.1803L1.48944 6.90983H7.75492L10 1Z"
                  fill="#FDB022"
                  fillOpacity="0.5"
                />
              </svg>
            </div>
            <span className={Styles.hero__rating__text}>
              4.6/5 Top-Rated on AppSumo
            </span>
          </div>
        </div>

        <div className={Styles.hero__partners}>
          <p className={Styles.hero__partners__label}>As seen on:</p>
          <div className={Styles.hero__partners__logos}>
            <img
              src="/Images/appsumo-seeklogo.png"
              alt="AppSumo"
              className={Styles.hero__partners__logo}
            />
            <img
              src="/Images/mindvalley-seeklogo.png"
              alt="Mindvalley"
              className={`${Styles.hero__partners__logo} ${Styles.hero__partners__logo_mindvalley}`}
            />
            <img
              src="/Images/venture-beat-seeklogo.png"
              alt="VentureBeat"
              className={Styles.hero__partners__logo}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingHero;
